(function($){
  $(function(){
    // Global Variables
    var $window = $(window);
    
    // build tabs 
    var hTabs = $('ul.tabs.horizontal'),
        tabBreak = 1024, //Breakpoint to turn into tabs
        $tabTitleClones = hTabs.parent().find('.tabTitleClones');
    
    if (hTabs.length){
      var setContentHeight = function(con,tab){
        //var curItemHeight = con.outerHeight()+15;
        var curItemHeight = con.outerHeight()+64;
        if ($(window).width() < tabBreak) {
            curItemHeight = con.outerHeight();
        }
        tab.css('min-height', curItemHeight);
      };

      hTabs.each(function(idx,itm){
        var idxClass = "tabs" + idx,
            curTab = $(itm),
            tabContent = curTab.find('li > .content');

        curTab.addClass(idxClass);

        var tabfunc = [
          {
            //function caled on mobile sizes
            min: 0,
            max: (tabBreak - 1),
            enter: function() {
              tabContent.hide();

              curTab.children('li').each(function (idx3, listItem) {
                var curItem = $(listItem),
                    curItemContent = curItem.find('>.content');

                // Create clones of title elements outside of the tab UL
                curItem.children('.title').clone().appendTo(curTab.parent().find('.tabTitleClones'));

                $tabTitleClones.children('.title').eq(idx3).on('click.vTabMobile', function (event) {

                  var $this = $(this);
                  /*
                  $this.next('.content').fadeToggle(200);
                  $this.parent('li').toggleClass(actClass);
                  */

                    if (!curItem.hasClass(actClass)) {
                        $window.off('resize.' + idxClass);

                        curTab.find('.tabs > li > .content').fadeOut(125).promise().done(function () {
                            curTab.find('>li').removeClass(actClass).find('> .content').css('opacity', '0');
                            curTab.find('>li').removeClass(actClass).find('> .content').css('display', 'none');
                            curItemContent.show();
                            setContentHeight(curItemContent, curTab);

                            $window.on('resize.' + idxClass, function () {
                                setContentHeight(curItemContent, curTab);
                            });

                            curItem.addClass(actClass);

                            $tabTitleClones.children().removeClass(actClass);
                            $this.addClass(actClass);

                            curItemContent.animate({
                                opacity: 1
                            }, 200, function () {
                                $window.trigger('resize');
                            });
                        });
                    }

                });
              });

              //curTab.children('li:first-child').find('>.title').trigger('click');
                $tabTitleClones.children(':first-child').each(function (idx4, listItem) {
                    console.log(listItem);
                }).trigger('click');
              $window.trigger('resize');
            },
            exit: function() {
              //curTab.find('li > .title').off('click.vTabMobile');
              $tabTitleClones.children().remove();
              curTab.find('li').removeClass(actClass);
            }
          },
          {
            //function caled on desktop sizes
            min: tabBreak,
            max: 99999,
            enter: function() {                  
              tabContent.hide();

              curTab.children('li').each(function (idx2, listItem) {
                var curItem = $(listItem),
                    curItemContent = curItem.find('>.content');

                curItem.children('.title').on('click.vTabFull', function(){
                  if(!curItem.hasClass(actClass)){
                    $window.off('resize.' + idxClass);  
                    
                    curTab.find('.tabs > li > .content').fadeOut(125).promise().done(function () {
                        curTab.find('>li').removeClass(actClass).find('> .content').css('opacity', '0');
                        curTab.find('>li').removeClass(actClass).find('> .content').css('display', 'none');
                        curItemContent.show();
                        setContentHeight(curItemContent,curTab);
                      
                        $window.on('resize.' + idxClass, function() { 
                            setContentHeight(curItemContent,curTab); 
                        }); 
                      
                        curItem.addClass(actClass);
                        curItemContent.animate({
                        opacity: 1  
                        }, 200, function () {
                        $window.trigger('resize');
                        });
                    });
                  }
                }); 
               
              });
              
              curTab.children('li:first-child').find('> .title').trigger('click');
              $window.trigger('resize');
            },
            exit: function () {
              curTab.find('li').removeClass(actClass);
              $window.off('resize.' + idxClass);
              curTab.find('li > .title').off('click.vTabFull');
              curTab.find('li > .content').removeAttr('style')
              curTab.css('min-height', '');
            }
          }
        ];

        breakdance(tabfunc);

      });
      
      // accessibility support
      hTabs.find('li > .title').attr('tabindex', '0').attr('role', 'button').on('keyup', function(e){
        var keyCode = e.which;
        if ((keyCode === 13) || (keyCode === 32)) {
          $(this).click();
        }
      });
    }
  });  
})($JQ);